<template>
  <div
    class="
      tw-relative
      tw-text-sf-gray
      tw-text-sm
      tw-leading-[1.4]
      tw-w-full
      tw-group/name
    "
    data-testid="account-name-cell"
  >
    <span class="tw-inline-flex tw-flex-col">
      <span
        v-if="showAccountOriginalName"
        class="tw-inline-block tw-text-xs tw-text-sf-gray-darker"
        >{{ originalAccountName }}</span
      >
      <span class="tw-inline-block">{{ accountName }}</span>
    </span>

    <SfButton
      v-if="newAdjustmentPath"
      class="
        tw-hidden tw-absolute tw-top-[50%] tw--translate-y-1/2 tw-right-0
        group-hover/name:tw-inline-flex
      "
      :variant="'default'"
      small
      @click="handleNewAdjustmentClick"
    >
      {{ I18n.t('adjustment.title_new') }}
    </SfButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import SfButton from '@app/shared/vue/components/sf-button/sf-button.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { openNewAdjustmentModal } from './utils/open-new-adjustment-modal'

interface Props {
  accountName: string
  originalAccountName?: string
  newAdjustmentPath?: string
}

const {
  accountName = ' ',
  originalAccountName,
  newAdjustmentPath,
} = defineProps<Props>()

const emit =
  defineEmits<{
    'clicked-new-adjustment': []
  }>()

const I18n = useI18n()

const showAccountOriginalName = computed(() => {
  return originalAccountName && originalAccountName !== accountName
})

const handleNewAdjustmentClick = () => {
  if (!newAdjustmentPath) {
    return
  }

  emit('clicked-new-adjustment')
  openNewAdjustmentModal(newAdjustmentPath)
}
</script>
